import React, { useState } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';

const ExpenseEditModal = ({ show, handleClose }) => {
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Edit Expense</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Expense Type:</Form.Label>
                            <Form.Control type="text" placeholder="Enter expense type" />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Expense Description:</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder="Enter expense description" />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Expense Amount ($):</Form.Label>
                            <Form.Control type="number" placeholder="Enter amount" />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Driver Name:</Form.Label>
                            <Form.Select>
                                <option>Select Driver</option>
                                <option>Driver A</option>
                                <option>Driver B</option>
                                <option>Driver C</option>
                                <option>Driver D</option>
                                <option>Driver E</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Expense Date:</Form.Label>
                            <Form.Control type="text" placeholder="Enter expense date manually" />
                        </Form.Group>

                        {/* Expense Date Range */}
                        <Form.Group className="mb-3">
                            <Form.Label>Expense Date Range:</Form.Label>
                            <DatePicker
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => setDateRange(update)}
                                isClearable
                                placeholderText="Select date range"
                                className="form-control w-100"
                            />
                        </Form.Group>

                        <Button variant="primary" onClick={handleClose}>
                            Save
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ExpenseEditModal;